import { DEFAULT_CUSTOM_RADIUS } from '~/src/config/constants';

export const getCustomRadius = (business) => {
    return business.info.custom_radius
        ? business.info.custom_radius
        : DEFAULT_CUSTOM_RADIUS;
};

export default getCustomRadius;
